module.exports = {"website":{"baseUrl":"$WWW_BASE_URL"},"apiMyBooking":{"baseUrl":"$APIMYBOOKING_BASE_URL"},"apiLocations":{"baseUrl":"$APILOCATIONS_BASE_URL"},"oauth":{"baseUrl":"$APIMYBOOKING_BASE_URL","clientId":"frontend-client-id-not-used-by-backend","cookieSecure":"$COOKIE_SECURE"},"cookiesGlobalDomain":"$COOKIES_GLOBAL_DOMAIN"}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./config/config.json
// module id = 17
// module chunks = 1